export const EMBED_WIDTH = 800;
export const EMBED_HEIGHT = 410;

export const MAX_EMBED_WIDTH = EMBED_WIDTH * 2;
export const MAX_EMBED_HEIGHT = EMBED_HEIGHT * 5;
